/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-array-constructor */
/* eslint-disable no-new-wrappers */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import queryString from 'query-string';
//import '../css/mediaWall.css';

// import Splah from "../containers/guestBook/Splah";
import CardContent from '../containers/guestBook/CardContent';
import CardImage from '../containers/guestBook/CardImage';
import CardItem from '../components/guestBook/CardItem';
import $ from 'jquery';
// import screenfull from "screenfull";
import { Helmet } from 'react-helmet';

const { Base64 } = require('js-base64');
const moment = require('moment');

class GuestBookTablet extends PureComponent {
  state = {
    cardIdx: 0,
    painting: false,
    filling: false,
    btnName: 'Paint',
    rangeValue: 2.5,
    color: '#2c2c2c',
    size: 2.5,
    selectContentSerial: 0,
    selectStillSerial: 0,
    selectCardIdx: 0,
    step: -1,
    open: false,
    pen: 8,
    loc: 'B',
  };
  interval = null;
  canvas = '';
  ctx = '';
  colors = '';
  range = '';
  mode = '';

  /*
    mouse={x: 0, y: 0}
    previous = {x: 0, y: 0}
    pathsry=[]
    points=[]
    */
  lastX = 0;
  lastY = 0;
  mouseX = 0;
  mouseY = 0;
  //canvasOffset = $('#jsCanvas').offset()
  //offsetX = this.canvasOffset.left;
  //offsetY = this.canvasOffset.top
  points = [];

  cardImg = '';
  interval = null;
  timer = 0;

  INITIAL_COLOR = '#2c2c2c';
  CANVAS_SIZE = '500';
  CANVAS_WIDTH = $('#canvas_wrap').width();
  CANVAS_HEIGHT = $('#canvas_wrap').height() - 30;

  componentDidMount = () => {
    // const { history } = this.props;

    this._check();
    //this._getCard()

    window.addEventListener('resize', this._resize);
    this.interval = setInterval(() => {
      this._onMouseMoveCheck();
    }, 1000);
    window.addEventListener('mousemove', this._onMove);
    window.addEventListener('touchmove', this._onMove);

    this.canvas = document.getElementById('jsCanvas');

    this.ctx = this.canvas.getContext('2d');
    this.colors = document.getElementsByClassName('pen');
    this.range = document.getElementById('jsRange');
    this.mode = document.getElementById('jsMode');
    this.saveBtn = document.getElementById('jsSave');

    this.canvas.width = this.CANVAS_WIDTH;
    this.canvas.height = this.CANVAS_HEIGHT;

    this.ctx.fillStyle = 'white';
    this.ctx.fillRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
    this.ctx.strokeStyle = this.INITIAL_COLOR;
    this.ctx.fillStyle = this.INITIAL_COLOR;
    this.ctx.lineWidth = 2.5;
    this.ctx.lineCap = 'round';

    //if (this.canvas) {

    this.canvas.addEventListener('mousemove', this.onMouseMove);
    this.canvas.addEventListener('mousedown', this.startPainting);
    this.canvas.addEventListener('mouseup', this.stopPainting);
    //this.canvas.addEventListener("mouseleave", this.stopPainting);
    this.canvas.addEventListener('click', this.handleCanvasClick);

    this.canvas.addEventListener('touchmove', this.onTouchMove, false);
    this.canvas.addEventListener('touchstart', this.onTouchStart, false);
    this.canvas.addEventListener('touchend', this.onTouchEnd, false);

    //this.canvas.addEventListener("contextmenu", handleCM);
    //this.range.addEventListener("input", this.handleRangeChange);
    //this.mode.addEventListener("click", this.handleModeClick);
    this.saveBtn.addEventListener('click', this.handleSaveClick);

    //}
    Array.from(this.colors).forEach((color) =>
      color.addEventListener('click', this.handleColorClick)
    );

    /*
        setTimeout(()=>{ 
            this.setState({
                step: 0
            })
            this._getCard()
        }, 4000)
        */
  };
  componentWillUnmount = () => {
    clearInterval(this.interval);
    window.removeEventListener('mousemove', this._onMove);
    window.removeEventListener('touchmove', this._onMove);
  };
  _onMove = () => {
    //console.log('move')
    this.timer = 0;

    //this.setState({ timer: 0})
  };
  _onMouseMoveCheck = () => {
    //const { timer } = this.state
    //console.log(this.timer)
    if (this.timer >= 60 * 10) {
      if (window.ReactNativeWebView) {
        var records = [{ back: 'home' }];
        window.ReactNativeWebView.postMessage(JSON.stringify(records));
      } else {
        //alert('no mobile')
      }
      //이동....
      this.timer = 0;
    } else {
      //console.log(timer)
      //this.setState({ timer: timer + 1})
      this.timer = this.timer + 1;
    }
  };
  _onFullscreen = () => {
    if (document.documentElement.requestFullScreen) {
      document.querySelector('#mobile').requestFullscreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
      document.querySelector('#mobile').webkitRequestFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.querySelector('#mobile').mozRequestFullScreen();
    } else if (document.documentElement.msRequestFullscreen) {
      document.querySelector('#mobile').msRequestFullscreen(); // IE
    }

    /*
        const element = document.getElementsByClassName('mobile')[0];
        //screenfull.request(findDOMNode(this.player))
        //document.element.requestFullscreen();
        if(screenfull.isFullscreen) {
            document.exitFullscreen(); 
        } else {
            screenfull.request(element)
        }
        */
  };
  _check = () => {
    const { location } = this.props.childProps;
    const query = queryString.parse(location.search);
    let code = query.p;
    //console.log(code)
    if (code === null || code === undefined || code === '') {
      //history.push('/error-404')
      alert('잘못된 주소입니다. 큐알코드를 스캔해주세요');
    } else {
      /*
            this._getCard()

            this.setState({
                loc: code
            })
            
            setTimeout(()=>{ 
                this.setState({
                    step: 0
                })
            }, 5000)
            */
      code = Base64.decode(code);

      //code = this.unEncrypt(code)
      const pos = code.indexOf('|');
      //            console.log(code)
      if (pos < 0) {
        //alert(pos, code)
        //history.push('/error-404')
        //alert('no gubunja')
        alert('잘못된 주소입니다. 큐알코드를 스캔해주세요.');
      } else {
        const server = moment(new Date()).format('YYYYMMDDhhmmss');
        const arr = code.split('|');
        const timestamp = arr[0];
        const loc = arr[1];

        //console.log(server, timestamp)

        if (parseInt(server) > parseInt(timestamp)) {
          //URl 파기
          //history.push('/error-404')
          alert('큐알코드를 다시 스캔해주세요');
        } else {
          //console.log('sucess')
          this._getCard();

          this.setState({
            timestamp,
            loc,
          });

          setTimeout(() => {
            this.setState({
              step: 0,
            });
          }, 2500);
        }
      }
    }
  };
  unEncrypt = (theText) => {
    let output = new String();
    let Temp = new Array();
    let Temp2 = new Array();

    const TextSize = theText.length;

    for (let i = 0; i < TextSize; i++) {
      Temp[i] = theText.charCodeAt(i);
      Temp2[i] = theText.charCodeAt(i + 1);
    }

    for (let j = 0; j < TextSize; j = j + 2) {
      output += String.fromCharCode(Temp[j] - Temp2[j]);
    }
    return output;
  };
  handleColorClick = (event) => {
    //console.log('sf')
    //this._sound()
    const color = event.target.style.backgroundColor;
    this.ctx.strokeStyle = color;
    this.ctx.fillStyle = color;

    this.setState({
      color,
    });
  };
  onMouseMove = (event) => {
    const { painting, size, color } = this.state;
    //const x = event.offsetX;
    //const y = event.offsetY;

    event.preventDefault();
    //const offset = $('#jsCanvas').offset()

    const x = event.offsetX;
    const y = event.offsetY;

    //this.mouseX = parseInt(event.clientX-offset.left)
    //this.mouseY = parseInt(event.clientY-offset.top)
    this.mouseX = x; //parseInt(event.clientX - this.offsetX)
    this.mouseY = y; //parseInt(event.clientY - this.offsetY)

    //if(!filling) {
    if (!painting) {
      //this.ctx.beginPath();
      //this.ctx.moveTo(x, y);
    } else {
      //this.previous = {x: this.mouse.x, y: this.mouse.y, size: this.ctx.lineWidth, color: this.ctx.strokeStyle}
      //this.mouse = this._mousePos(event)

      //this.ctx.lineTo(x, y);
      this.ctx.lineTo(this.mouseX, this.mouseY);
      this.ctx.stroke();
      this.lastX = this.mouseX;
      this.lastY = this.mouseY;
      this.points.push({
        x: this.mouseX,
        y: this.mouseY,
        size: size,
        color: color,
        mode: 'draw',
      });
    }
    //}
  };
  startPainting = (event) => {
    const { size, color } = this.state;
    event.preventDefault();
    /*
        this.previous={x: this.mouse.x, y: this.mouse.y}
        this.mouse = this._mousePos(event);       
        this.points=[];
        this.points.push({x: this.mouse.x, y: this.mouse.y, size: this.ctx.lineWidth, color: this.ctx.strokeStyle}) 
        */
    // const offset = $('#jsCanvas').offset()

    const x = event.offsetX;
    const y = event.offsetY;

    this.mouseX = x; //parseInt(event.clientX-offset.left)
    this.mouseY = y; //parseInt(event.clientY-offset.top)
    this.ctx.beginPath();

    if (this.ctx.lineWidth !== size) {
      this.ctx.lineWidth = size;
    }

    if (this.ctx.strokeStyle !== color) {
      this.ctx.strokeStyle = color;
      this.ctx.fillStyle = color;
    }

    this.ctx.moveTo(this.mouseX, this.mouseY);
    this.points.push({
      x: this.mouseX,
      y: this.mouseY,
      size: size,
      color: color,
      mode: 'begin',
    });

    this.lastX = this.mouseX;
    this.lastY = this.mouseY;

    this.setState({
      painting: true,
    });
  };
  stopPainting = (event) => {
    //event.preventDefault();
    const { size, color } = this.state;
    //const offset = $('#jsCanvas').offset()

    //this.mouseX = parseInt(event.clientX-offset.left)
    //this.mouseY = parseInt(event.clientY-offset.top)
    const x = event.offsetX;
    const y = event.offsetY;
    this.mouseX = x;
    this.mouseY = y;

    this.points.push({
      x: this.mouseX,
      y: this.mouseY,
      size: size,
      color: color,
      mode: 'end',
    });
    //this.pathsry.push(this.points)

    this.setState({
      painting: false,
    });
  };
  onTouchMove = (event) => {
    event.preventDefault();

    const { size, color, painting } = this.state;
    let offset = $('#jsCanvas').offset();
    var touches = event.changedTouches;
    const x = touches[0].pageX - offset.left;
    const y = touches[0].pageY - offset.top;

    this.mouseX = x;
    this.mouseY = y;

    if (!painting) {
      //this.ctx.beginPath();
      //this.ctx.moveTo(x, y);
    } else {
      //this.previous = {x: this.mouse.x, y: this.mouse.y, size: this.ctx.lineWidth, color: this.ctx.strokeStyle}
      //this.mouse = this._mousePos(event)

      //this.ctx.lineTo(x, y);
      this.ctx.lineTo(this.mouseX, this.mouseY);
      this.ctx.stroke();
      this.lastX = this.mouseX;
      this.lastY = this.mouseY;
      this.points.push({
        x: this.mouseX,
        y: this.mouseY,
        size: size,
        color: color,
        mode: 'draw',
      });
    }

    //console.log()

    //console.log(x, y)
    /*
        if(!filling) {
            if (!painting) {
                //this.ctx.beginPath();
                //this.ctx.moveTo(x, y);
            } else {
                this.ctx.lineTo(x, y);
                this.ctx.stroke();
            }
        }
        */
  };
  onTouchStart = (event) => {
    const { size, color, penShow } = this.state;
    if (penShow) {
      this._penHide();
    }
    let offset = $('#jsCanvas').offset();
    var touches = event.changedTouches;
    const x = touches[0].pageX - offset.left;
    const y = touches[0].pageY - offset.top;

    this.mouseX = x;
    this.mouseY = y;

    this.ctx.beginPath();

    if (this.ctx.lineWidth !== size) {
      this.ctx.lineWidth = size;
    }

    if (this.ctx.strokeStyle !== color) {
      this.ctx.strokeStyle = color;
      this.ctx.fillStyle = color;
    }

    this.ctx.moveTo(this.mouseX, this.mouseY);
    this.points.push({
      x: this.mouseX,
      y: this.mouseY,
      size: size,
      color: color,
      mode: 'begin',
    });

    this.lastX = this.mouseX;
    this.lastY = this.mouseY;

    this.setState({
      painting: true,
    });
  };
  onTouchEnd = (event) => {
    event.preventDefault();

    const { size, color } = this.state;
    let offset = $('#jsCanvas').offset();
    var touches = event.changedTouches;
    const x = touches[0].pageX - offset.left;
    const y = touches[0].pageY - offset.top;

    this.mouseX = x;
    this.mouseY = y;

    this.points.push({
      x: this.mouseX,
      y: this.mouseY,
      size: size,
      color: color,
      mode: 'end',
    });

    this.ctx.closePath();
    this.setState({
      painting: false,
    });
  };
  _selectContent = (contentSerial, imageLO) => {
    this.setState({
      selectContentSerial: contentSerial,
      imageLO,
      step: 1,
    });
  };
  _selectStill = (stillSerial, stillImg) => {
    this.setState({
      selectStillSerial: stillSerial,
      stillImg,
      step: 2,
    });
  };
  _next = (step) => {
    const { selectContentSerial, selectStillSerial, selectCardIdx } =
      this.state;
    //console.log(step)
    //this._sound()
    if (step === 1) {
      if (selectContentSerial === 0) {
      } else {
        this.setState({
          step: step,
        });
      }
    }
    if (step === 2) {
      if (selectStillSerial === 0) {
        //toast.warn('스틸컷을 선택해 주세요')
      } else {
        this.setState({
          step: step,
        });
      }
    }
    if (step === 3) {
      if (selectCardIdx === 0) {
        //toast.warn('메모지를 선택해 주세요')
      } else {
        this.setState({
          step: step,
        });
      }
    }
  };
  _pre = (step) => {
    //this._sound()
    this.setState({
      step: this.state.step === 0 ? 0 : step,
    });
  };
  _sound = () => {
    var audio = document.getElementById('audio_play');
    //console.log(audio)
    if (audio.paused) {
      audio.play();
    } else {
      audio.pause();
      audio.currentTime = 0;
    }
  };
  _getCard = async () => {
    const result = await this._getCardApi();
    const intReturn = result.data[0].intReturn;
    const cardList = result.data[0].listData;
    //console.log(cardList)
    if (intReturn === 0) {
      this.setState({
        cardList,
      });
    }
  };
  _getCardApi = () => {
    const { apiUrl1 } = this.props;

    return axios
      .post(apiUrl1 + '/getCard', {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
      });
  };
  _selectImg = (cardIdx) => {
    // const { loc } = this.props;
    const { selectContentSerial, selectStillSerial, cardList, imageLO } =
      this.state;
    //console.log(cardList[cardIdx-1])
    //console.log(cardIdx)

    if (selectContentSerial === 0) {
      //toast.warn('작품을 선택해주세요.');
      return false;
    }
    if (selectStillSerial === 0) {
      //toast.warn('이미지를 선택해주세요.');
      return false;
    }

    const img = new Image();
    img.src = '/img/guestBook/' + cardList[cardIdx - 1].img;

    this.cardImg = '/img/guestBook/' + cardList[cardIdx - 1].img;

    const logoImg = new Image();
    logoImg.src = imageLO;

    //console.log(imageLO)
    //setTimeout(()=>{
    // let locName;
    // const day = moment(new Date()).format("YYYY년 MM월 DD일");
    this.ctx.drawImage(img, 0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
    /*
            this.ctx.font = '20px GmarketSans';
            this.ctx.fillStyle = "gray";
            if(loc === 'B') {
                locName = '[부산점] ' + day
            } else if(loc === 'S') {
                locName = '[합정점] ' + day
            } else if(loc === 'D') {
                locName = '[대전점] ' + day
            } else if(loc === 'G') {
                locName = '[광주점]1 ' + day
            } 
            //console.log(locName)
            */
    //this.ctx.fillText(locName, this.CANVAS_WIDTH-300, this.CANVAS_HEIGHT-30);
    //this.ctx.drawImage(logoImg, 0, 0, 161, 80)
    //this.points.push({x: 0, y: 0, size: size, color: color, mode: 'start' })

    //}, 700)
    setTimeout(() => {
      this._resize();
    }, 700);

    this.setState({
      cardIdx,
      selectCardIdx: cardIdx,
      step: 3,
    });
  };
  _resize = () => {
    //console.log('resize')
    // const { loc } = this.props;
    const width = $('#canvas_wrap').width();
    const height = $('#canvas_wrap').height() - 30;
    // let locName = "";

    //console.log(width, height)
    this.CANVAS_WIDTH = width;
    this.CANVAS_HEIGHT = height;

    this.canvas.width = width;
    this.canvas.height = height;

    //console.log(this.cardImg)

    const img = new Image();
    img.src = this.cardImg;

    // const day = moment(new Date()).format("YYYY년 MM월 DD일");
    //setTimeout(()=>{
    this.ctx.drawImage(img, 0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);

    /*
            this.ctx.font = '20px GmarketSans';
            this.ctx.fillStyle = "gray";
            if(loc === 'B') {
                locName = '[부산점] ' + day
            } else if(loc === 'S') {
                locName = '[합정점] ' + day
            } else if(loc === 'D') {
                locName = '[대전점] ' + day
            } else if(loc === 'G') {
                locName = '[광주점]1 ' + day
            } 
            //console.log(locName)
            */
    //this.ctx.fillText(locName, this.CANVAS_WIDTH-300, this.CANVAS_HEIGHT-30);
    //this.ctx.drawImage(logoImg, 0, 0, 161, 80)
    ///this.points.push({x: 0, y: 0, size: size, color: color, mode: 'start' })
    ///}, 700)

    //console.log($('#msg').width())
    //console.log(this.canvas.parentElement)
    //console.log(this.canvas.parentElement.width,this.canvas.parentElement.height )
  };
  _renderItem = () => {
    const { cardList, selectCardIdx } = this.state;
    const list = cardList.map((item, index) => {
      return (
        <CardItem
          key={index}
          cardIdx={item.cardIdx}
          img={item.img}
          title={item.title}
          selectImg={this._selectImg}
          selectCardIdx={selectCardIdx}
          //step={step}
          //next={this._next}
          //pre={this._pre}
        />
      );
    });

    return list;
  };
  _undo = () => {
    const { penShow } = this.state;
    //console.log(this.pathsry)
    //this.pathsry.splice(-1, 1);
    //this._drawPaths();
    if (penShow) {
      this._penHide();
    }

    if (this.points.length > 1) {
      this.points.pop();
      //this.points.splice(-1, 1);
      this._redrawAll();
    }
  };
  _redrawAll = () => {
    // const { loc } = this.props;
    if (this.points.length === 0) {
      return;
    }
    //console.log(this.points)

    this.ctx.clearRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);

    const img = new Image();
    img.src = this.cardImg;

    //setTimeout(()=>{
    // let locName;
    // const day = moment(new Date()).format("YYYY년 MM월 DD일");
    this.ctx.drawImage(img, 0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
    /*
            this.ctx.font = '20px GmarketSans';
            this.ctx.fillStyle = "gray";
            if(loc === 'B') {
                locName = '[부산점] ' + day
            } else if(loc === 'S') {
                locName = '[합정점] ' + day
            } else if(loc === 'D') {
                locName = '[대전점] ' + day
            } else if(loc === 'G') {
                locName = '[광주점]1 ' + day
            } 
            */
    //this.ctx.fillText(locName, this.CANVAS_WIDTH-300, this.CANVAS_HEIGHT-30);
    //}, 700)

    //this.ctx.fillRect(0, 0, this.CANVAS_SIZE, this.CANVAS_SIZE);
    for (let i = 0; i < this.points.length; i++) {
      let pt = this.points[i];
      let begin = false;

      if (this.ctx.lineWidth !== pt.size) {
        this.ctx.lineWidth = pt.size;
        //console.log('not width')
        //begin = true
      }
      if (this.ctx.strokeStyle !== pt.color) {
        this.ctx.strokeStyle = pt.color;
        this.ctx.fillStyle = pt.color;
        //console.log('not color')
        //begin = true
      }
      if (pt.mode === 'begin' || begin) {
        this.ctx.beginPath();
        this.ctx.moveTo(pt.x, pt.y);
        //console.log('begin')
      }
      this.ctx.lineTo(pt.x, pt.y);
      if (pt.mode === 'end' || i === this.points.length - 1) {
        this.ctx.stroke();
        //console.log('end')
      }
      if (pt.mode === 'draw') {
        this.ctx.stroke();
      }
    }
    this.ctx.stroke();
  };
  _repaint = () => {
    const { penShow } = this.state;
    if (penShow) {
      this._penHide();
    }

    if (this.points.length > 0) {
      this.ctx.clearRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);

      const img = new Image();
      img.src = this.cardImg;
      this.ctx.drawImage(img, 0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
      this.points = [];
    } else {
    }
  };
  _penShow = () => {
    this.setState({
      penShow: true,
    });
  };
  _penHide = () => {
    this.setState({
      penShow: false,
    });
  };
  _selectColor = (pen, color) => {
    this.setState({
      pen,
      color,
    });
  };
  _penShowChange = () => {
    //console.log('test')
  };
  /*
    handleRangeChange = (event) => {
        const size = event.target.value;
        this.ctx.lineWidth = size;
        this.setState({
            size
        })
    }
    */
  _rangeChange = (event) => {
    //console.log(event.target.value)
    this.setState({
      rangeValue: event.target.value,
      size: event.target.value,
    });
  };
  handleSaveClick = async () => {
    //console.log(this.points.length)
    if (this.points.length <= 0) {
      alert('내용을 작성해주세요');
      return false;
    }

    const { apiUrl1 } = this.props;
    //큐알코드 접속시 loc 변수 querystring으로 처리.
    const {
      selectContentSerial,
      selectStillSerial,

      selectCardIdx,
      loc,
    } = this.state;
    const imgBase64 = this.canvas.toDataURL('image/jpeg', 'image/octet-stream');
    const decodImg = atob(imgBase64.split(',')[1]);

    //console.log(loc)

    let array = [];
    for (let i = 0; i < decodImg.length; i++) {
      array.push(decodImg.charCodeAt(i));
    }

    //console.log(selectContentSerial, selectStillSerial)

    const file = new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
    const fileName = 'canvas_img_' + new Date().getMilliseconds() + '.jpg';
    let formData = new FormData();

    formData.append('card_idx', selectCardIdx);
    formData.append('selectContentSerial', selectContentSerial);
    formData.append('selectStillSerial', selectStillSerial);
    formData.append('loc', loc);
    formData.append('file', file, fileName);
    formData.append('platform', 'T');

    const result = await this._post(formData);
    //console.log(result.data)
    const intReturn = result.data.intReturn;
    const img = result.data.img;
    //console.log(imageLO, stillImg)

    if (intReturn === 0) {
      this.ctx.clearRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
      this.ctx.strokeStyle = this.INITIAL_COLOR;
      this.ctx.fillStyle = this.INITIAL_COLOR;
      this.ctx.lineWidth = 2.5;

      this.setState({
        selectContentSerial: 0,
        selectStillSerial: 0,
        selectCardIdx: 0,
        cardIdx: 0,
        step: 100,
        open: true,
        img: apiUrl1 + '/' + img,
      });

      setTimeout(() => {
        this.setState({
          open: false,
        });
      }, 4000);
    } else {
      alert('등록중 오류가 발생했습니다.');
      //toast.error('등록중 오류가 발생했습니다.')
    }

    //console.log(result.data)
  };
  _post = (formData) => {
    const { apiUrl1 } = this.props;
    return axios
      .post(apiUrl1 + '/upload', formData)
      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _write = () => {
    this.setState({
      step: 0,
    });
  };
  _back = () => {
    const { step } = this.state;
    this._sound();
    if (step === 0) {
    } else {
      this.setState({
        step: step - 1,
      });
    }
  };
  _onClose = () => {
    this.setState({
      open: false,
    });
  };
  _home = () => {
    if (window.ReactNativeWebView) {
      var records = [{ back: 'home' }];
      window.ReactNativeWebView.postMessage(JSON.stringify(records));
    } else {
      //alert('no mobile')
    }
  };
  render() {
    const {
      cardList,

      rangeValue,

      selectContentSerial,
      selectStillSerial,
      imageLO,
      stillImg,
      img,
      step,
      open,
      pen,
    } = this.state;
    const { imgUrl } = this.props;
    let penClass = '';
    if (pen === 0) {
      penClass = 'slider yellow';
    } else if (pen === 1) {
      penClass = 'slider orange';
    } else if (pen === 2) {
      penClass = 'slider red';
    } else if (pen === 3) {
      penClass = 'slider pink';
    } else if (pen === 4) {
      penClass = 'slider purple';
    } else if (pen === 5) {
      penClass = 'slider blue';
    } else if (pen === 6) {
      penClass = 'slider green';
    } else if (pen === 7) {
      penClass = 'slider white';
    } else if (pen === 8) {
      penClass = 'slider black';
    }
    return (
      <Fragment>
        <Helmet>
          <link
            rel="stylesheet"
            type="text/css"
            href="https://www.aniplustv.com/common/css/mediaWall_1.css"
          />
        </Helmet>
        <div
          className="wrap mobile"
          style={{
            backgroundColor: '#000',
            display: step === -1 ? '' : 'none',
          }}
        >
          <div className="home">
            <div className="m_titSplash">
              <img
                src={imgUrl + '/img/guestbook/m_tit_guestBook.png'}
                alt="방명록. 원하시는 작품으로 당신의 소중한 발자취를 남겨주세요!"
              />
            </div>
          </div>
        </div>

        <div
          className="wrap mobile"
          id="mobile"
          style={{
            backgroundColor: '#000',
            display: step === 100 ? '' : 'none',
          }}
        >
          <div className="home">
            <div
              className="m_titSplash"
              style={{ fontFamily: 'GmarketSansBold', fontSize: 14 }}
            >
              성공적으로 등록되었습니다.
            </div>
            <div
              className="m_titSplash"
              onClick={this._write}
              style={{
                display: 'flex',
                marginTop: 40,
                width: 145,
                height: 40,
                /*borderStyle: 'groove', borderWidth: 2, borderColor: '#fff',*/ justifyContent:
                  'center',
                alignItems: 'center',
                borderRadius: 6,
                fontSize: 12,
                backgroundColor: '#ff5d24',
              }}
            >
              작성하기
            </div>
            <div
              className="m_titSplash"
              onClick={this._home}
              style={{
                display: 'flex',
                marginTop: 90,
                width: 145,
                height: 40,
                /*borderStyle: 'groove', borderWidth: 2, borderColor: '#fff',*/ justifyContent:
                  'center',
                alignItems: 'center',
                borderRadius: 6,

                backgroundColor: 'gray',
                fontSize: 13,
              }}
            >
              나가기
            </div>
          </div>
        </div>
        {open || step === 100 || step === -1 ? null : (
          <header className="header1">
            <nav className="nav">
              {/*
                                <input type="checkbox" id="btn_ctrlMenu"/>
                                <div className="menuCtrl_wrap">
                                    <div className="menuCtrl">
                                        <button type="button" onClick={this._back}>이전</button>
                                    </div>
                                </div>
                                */}
              {step === 0 ? null : (
                <button type="button" className="menuCtrl" onClick={this._back}>
                  이전
                </button>
              )}
            </nav>
          </header>
        )}
        <div
          className="wrap"
          style={{ display: step === 100 || step === -1 ? 'none' : '' }}
        >
          <div className="container_wall">
            <div className={'guestBook ctrl write'}>
              <audio
                id="audio_play"
                src={imgUrl + '/img/guestbook/tfile.mp3'}
              ></audio>

              <div className="ctrl_head">
                <h1 style={{ fontFamily: 'GmarketSansBold' }}>방명록</h1>
                <ol className="step">
                  {/*활성화 class = active */}
                  <li className={step === 0 ? 'active' : ''}>
                    <span style={{ fontFamily: 'GmarketSansBold' }}>
                      1. 작품선택
                    </span>
                  </li>
                  <li className={step === 1 ? 'active' : ''}>
                    <span style={{ fontFamily: 'GmarketSansBold' }}>
                      2. 스틸컷 선택
                    </span>
                  </li>
                  <li className={step === 2 ? 'active' : ''}>
                    <span style={{ fontFamily: 'GmarketSansBold' }}>
                      3. 메모지 선택
                    </span>
                  </li>
                  <li className={step === 3 ? 'active' : ''}>
                    <span style={{ fontFamily: 'GmarketSansBold' }}>
                      4. 방명록 남기기
                    </span>
                  </li>
                </ol>

                {/*<h3 className="dsc"><img src="/img/guestbook/ico_hand.png"/>원하시는 작품으로  당신의 소중한 발자취를 남겨주세요!</h3>*/}
              </div>
              <div className="ctrl_body">
                {step === 0 ? (
                  <CardContent
                    selectContentSerial={selectContentSerial}
                    selectContent={this._selectContent}
                    step={step}
                    next={this._next}
                    pre={this._pre}
                    type="tablet"
                  />
                ) : null}
                {step === 1 ? (
                  <CardImage
                    selectContentSerial={selectContentSerial}
                    selectStillSerial={selectStillSerial}
                    selectStill={this._selectStill}
                    step={step}
                    next={this._next}
                    pre={this._pre}
                    type="tablet"
                  />
                ) : null}
                {step === 2 ? (
                  <div className="container_wall">
                    <div className="list memo">
                      <ul style={{ marginBottom: 80 }}>
                        {cardList ? this._renderItem() : null}
                      </ul>
                    </div>
                  </div>
                ) : null}

                <div
                  className="guest_write "
                  style={{ display: step === 3 ? '' : 'none' }}
                >
                  <div className="guest_memo canvas_wrap" id="canvas_wrap">
                    {/*<img src="/img/guestbook/msg.png" alt="메세지 예시" />*/}
                    <canvas id="jsCanvas" style={{ marginTop: 15 }}></canvas>

                    {/*
                                            <div className="logo">
                                                <img src="img/img_logo2.png" alt="애니 타이틀 로고"/>
                                                <p className="date">
                                                    [부산점] 2021년 10월 28일
                                                </p>
                                            </div>
                                            <div className="bg_memo"><img src="img/bg_memo.png" alt="메모 배경"/></div>
                                            */}
                  </div>
                  <div className="btn_wrap">
                    <ul className="ani">
                      <li className="logo">
                        <img src={imageLO} alt="애니 타이틀 로고" />
                      </li>
                      <li className="stil">
                        <img src={stillImg} alt="스틸컷" />
                      </li>
                    </ul>
                    <div className="btn_ctrls">
                      <button
                        type="button"
                        className="btn_ctrl"
                        onClick={this._undo}
                      >
                        <img src={imgUrl + '/img/guestbook/ico_undo.png'} />
                        <p>UNDO</p>
                      </button>
                      <button
                        type="button"
                        className="btn_ctrl"
                        onClick={this._repaint}
                      >
                        <img src={imgUrl + '/img/guestbook/ico_reset.png'} />
                        <p>RESET</p>
                      </button>
                      <button
                        type="button"
                        className="btn_save"
                        id="jsSave"
                        style={{
                          fontFamily: 'GmarketSansBold',
                          height: 'calc(100% - 13.5625vw)',
                        }}
                      >
                        방명록 남기기
                      </button>
                    </div>
                  </div>

                  <div className="write_colors">
                    <div className="pens_wrap">
                      {/*활성화 class = active*/}
                      <div
                        className={pen === 0 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(233, 188, 23)' }}
                        onClick={() =>
                          this._selectColor(0, 'rgb(233, 188, 23)')
                        }
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_yell.png'}
                          alt="노랑색"
                        />
                      </div>
                      <div
                        className={pen === 1 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(232, 106, 21)' }}
                        onClick={() =>
                          this._selectColor(1, 'rgb(232, 106, 21)')
                        }
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_org.png'}
                          alt="오렌지색"
                        />
                      </div>
                      <div
                        className={pen === 2 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(233, 44, 35)' }}
                        onClick={() => this._selectColor(2, 'rgb(233, 44, 35)')}
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_red.png'}
                          alt="빨강색"
                        />
                      </div>
                      <div
                        className={pen === 3 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(233, 40, 126)' }}
                        onClick={() =>
                          this._selectColor(3, 'rgb(233, 40, 126)')
                        }
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_pink.png'}
                          alt="핑크색"
                        />
                      </div>
                      <div
                        className={pen === 4 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(153, 62, 235)' }}
                        onClick={() =>
                          this._selectColor(4, 'rgb(153, 62, 235)')
                        }
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_purple.png'}
                          alt="보라색"
                        />
                      </div>
                      <div
                        className={pen === 5 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(66, 139, 235)' }}
                        onClick={() =>
                          this._selectColor(5, 'rgb(66, 139, 235)')
                        }
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_blue.png'}
                          alt="파랑색"
                        />
                      </div>
                      <div
                        className={pen === 6 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(59, 188, 73)' }}
                        onClick={() => this._selectColor(6, 'rgb(59, 188, 73)')}
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_green.png'}
                          alt="초록색"
                        />
                      </div>
                      <div
                        className={pen === 7 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(255, 255, 255)' }}
                        onClick={() =>
                          this._selectColor(7, 'rgb(255, 255, 255)')
                        }
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_wh.png'}
                          alt="하얀색"
                        />
                      </div>
                      <div
                        className={pen === 8 ? 'pen active' : 'pen'}
                        style={{ color: 'rgb(0,0,0)' }}
                        onClick={() => this._selectColor(8, 'rgb(0,0,0)')}
                      >
                        <img
                          src={imgUrl + '/img/guestbook/pen_bk.png'}
                          alt="검정색"
                        />
                      </div>
                    </div>
                    <div className="slider_wrap">
                      <input
                        type="range"
                        id="jsRange"
                        className={penClass}
                        min="0.1"
                        max="5.0"
                        step="0.1"
                        value={rangeValue}
                        onChange={this._rangeChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {
                step === 3 ? null : null
                /*
                                    <div className="ctrl_foot">
                                        <button type="button" className={step === 0 ? '' : "active"} onClick={()=>{this._pre(step-1)}}>
                                            <img src="/img/guestbook/arrw_pre.png"/>&#160;&#160;PRE
                                        </button>
                                        <button type="button" className={step === 4 ? '' : "active"} onClick={()=>this._next(step+1)}>
                                            NEXT&#160;&#160;<img src="/img/guestbook/arrw_next.png"/>
                                        </button>
                                    </div>
                                    */
              }
              {open ? (
                <div className="popup">
                  <button
                    type="button"
                    className="btn_close"
                    onClick={this._onClose}
                  >
                    <img src="/img/guestbook/ico_close.png" alt="닫기" />
                  </button>
                  <div className="pop_chk">
                    <div className="guestBook_chk">
                      <div className="stil">
                        <img src={stillImg} />
                      </div>
                      <div className="guest_memo">
                        {/*
                                                    <div className="msg">
                                                        <img src="/img/guestbook/msg.png" alt="메세지 예시" />
                                                    </div>
                                                    */}
                        <div className="logo">
                          <img src={imageLO} alt="애니 타이틀 로고" />
                        </div>

                        <div className="bg_memo">
                          <img src={img} alt="메모 배경" />
                        </div>
                      </div>
                    </div>
                    {/*
                                            <div className="btn_chk">
                                                <button type="button">내폰에 저장하기</button>
                                                <button type="button" onClick={this._onClose}>닫기</button>
                                            </div>
                                            */}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(GuestBookTablet)));
